
<template>
<remainder-form></remainder-form>
</template>
<script >

import RemainderForm from "@/views/admin/components/Remainder-form.vue"

export default {
  components: { RemainderForm }
}
</script>

<style scoped>

</style>
